import { useEffect, useState } from "react";
import { useParams } from "react-router";
import SwitchAccess from "./SwitchAccess";
import ProfileActions from "./ProfileActions";
import { userServices } from "../APIServices/userServices";
import { Badge, Button } from "react-bootstrap";
import { RiBuilding2Line } from "react-icons/ri";
import { TiFolderOpen } from "react-icons/ti";
const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

const role = JSON.parse(localStorage.getItem("role"));
const timeZoneGMT = JSON.parse(localStorage.getItem("timeZoneGMT"));
const timeZone = JSON.parse(localStorage.getItem("timeZone"));
const studyStatusData = JSON.parse(localStorage.getItem("studyStatus"));
const clientLabel = JSON.parse(localStorage.getItem("clientLabel"));
const projectLabel = JSON.parse(localStorage.getItem("projectLabel"));
const loginType = JSON.parse(localStorage.getItem("loginType"));
const studyLogout = JSON.parse(localStorage.getItem("role"));
const studyManagement = JSON.parse(localStorage.getItem("studyManagement"));

const Navbar = ({ handleAddNewTab }) => {
  const { studyId } = useParams();
  const currentURL = window.location.href;
  const splitURL = currentURL.split("/");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [managementRole, setManagementRole] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    profileData();
  }, []);

  const profileData = async () => {
    const item1 = JSON.parse(localStorage.getItem("firstName"));
    const item2 = JSON.parse(localStorage.getItem("lastName"));
    if (item1) {
      setFirstName(item1);
    }
    if (item2) {
      setLastName(item2);
    }
  };

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    const currentDetails = async (e) => {
      let userData = await userServices.getCurrentUserDetails(e);
      setManagementRole(userData?.[1]?.management_name?.name);
      setImage(userData?.[0]?.user_id?.image);
    };
    currentDetails();
  }, [studyId]);

  return (
    <>
      <div style={{ background: "var(--blue)" }} className="shadow-lg">
        <div className="hstack justify-content-between p-2">
          <h4 className="text-white m-0">Galax®</h4>
          {/* <img src={MainLogo} alt="Company Logo" style={{height: 29}} /> */}
          <div className="hstack justify-content-between gap-2">
            <span className="text-white"><i className="fa-solid fa-earth-asia me-1 text-info"></i>Timezone: <b>{`${timeZone} (${timeZoneGMT})`}</b></span>
            <span className="text-white"><i className="fa-solid fa-building-user me-1 text-info"></i>Logged in as :{" "}
              <b>{studyLogout === "client" ? "Admin" : studyLogout === "user" ? managementRole : splitURL[3] === "etmf" ? studyManagement : studyManagement}</b>
            </span>
            <div className="hstack gap-1">
              <ProfileActions
                handleAddNewTab={handleAddNewTab}
                ProfileImage={image}
                firstName={firstName}
                lastName={lastName}
              />
              {loginType !== "direct" && !(studyLogout === "client" ||
                studyLogout === "user" ||
                studyLogout === "super_user") && (
                <SwitchAccess 
                  clientLabel={clientLabel}
                  projectLabel={projectLabel}
                  StudyMode={StudyMode}
                />
              )}
              <Button
                onClick={logout}
                variant="outline-danger"
                className="p-1 px-2 border-0 br3"
                style={{ fontSize: 13 }}
                title="Sign out from panel"
              >
                <i className="fa-solid fa-right-from-bracket me-1"></i>Signout
              </Button>
            </div>
          </div>
        </div>
      </div>
      {(role === "client" || role === "user") ? ( "" )  : 
        <div className="hstack justify-content-between filebar border-bottom" style={{ height: 35, padding: 5 }}>
          {/* App Section  */}
          <div className="hstack gap-2">
            {StudyMode && (
              <div className="hstack gap-2">
                <div className="text-dark m-0 hstack gap-1">
                  <RiBuilding2Line/> 
                  <span className="client1">{clientLabel}</span>
                </div>

                <div className="m-0 hstack gap-1 text-dark">
                  <TiFolderOpen />
                  <span className="projectid">{projectLabel}</span>
                </div>
              </div>
            )}
          </div>
          {/* Study Details  */}
          {StudyMode && (
              <div className="hstack gap-2">
                {(role !== "user" || role !== "client") && (
                  <Badge bg={(StudyMode === "DBP Mode" || StudyMode === "DV Mode") ? "warning-subtle" : (StudyMode === "Production Mode" || StudyMode === "SDV Live Mode" || StudyMode === "Read Only Live Mode" || StudyMode === "Live Mode") ? "success-subtle" : (StudyMode === "SDV QC Mode" || StudyMode === "QC Mode")  ? "danger-subtle" :""} className="text-dark hstack gap-1">
                    <div>
                      <i className={(StudyMode === "DBP Mode" || StudyMode === "DV Mode") ? "fa-solid fa-circle dbp__mode__color" : ""} />
                      <i className={(StudyMode === "Production Mode" || StudyMode === "SDV Live Mode" || StudyMode === "Read Only Live Mode" || StudyMode === "Live Mode") ? "fa-solid fa-circle live__mode__color" : ""} />
                      <i className={(StudyMode === "SDV QC Mode" || StudyMode === "QC Mode") ? "fa-solid fa-circle qc__mode__color" : ""} />
                    </div>
                    <span className="projectid"> {StudyMode}</span>
                  </Badge>
                )}
                <Badge bg="success-subtle" className="text-dark m-0 hstack gap-1">
                  <i className="fa-solid fa-folder live__mode__color" />
                  <span className="projectid capitalize">Status : {studyStatusData}</span>
                </Badge>
              </div>
          )}
        </div>
      }
    </>
  );
};

export default Navbar;
